import React, { useEffect, useState } from 'react'
import styles from './Summary.module.scss'
import { useTranslation } from 'react-i18next'
import {
  faBook,
  faHourglassHalf,
  faCheckCircle,
  faExclamationSquare,
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Col, Divider, Row } from 'antd'
import myStatistics from 'api/home/MyStatistics'
import useSWR from 'swr'
import { useSelector } from 'react-redux'
import { IMainState } from 'store/states'

export const CoursesSummary = () => {
  const [totalCourses, setTotalCourses] = useState(0)
  const [finishedCourses, setFinishedCourses] = useState(0)
  const [inProgressCourses, setInProgressCourses] = useState(0)
  const [pendingCourses, setPendingCourses] = useState(0)
  const [finishedCoursesPercent, setFinishedCoursesPercent] = useState(0)
  const [inProgressCoursesPercent, setInProgressCoursesPercent] = useState(0)
  const [pendingCoursesPercent, setPendingCoursesPercent] = useState(0)
  const [statistics, setStatistics] = useState<any>({})
  const { t } = useTranslation()
  const { counters } = useSelector(({ courses }: IMainState) => courses)

  const { data, isLoading } = useSWR('myStatisticsData', async () =>
  myStatistics()
)

  useEffect(() => {
    setTotalCourses(counters?.me)
    setFinishedCourses(data?.finish)
    setInProgressCourses(data?.inProgress)
    setPendingCourses(data?.pending)
    setFinishedCoursesPercent(data?.finishPercent)
    setInProgressCoursesPercent(data?.inProgressPercent)
    setPendingCoursesPercent(data?.pendingPercent)
  }, [counters?.me, data])

  const ProgressCard = (
    typeOf: string,
    amountOf: number,
    percentageOf: any
  ) => {
    const title = {
      total: t('home.lmsIndex.lmsMyCourses.courseSummary.allCourses'),
      finished: t('home.lmsIndex.lmsMyCourses.courseSummary.finished'),
      progress: t('home.lmsIndex.lmsMyCourses.courseSummary.inProgress'),
      pending: t('home.lmsIndex.lmsMyCourses.courseSummary.pending'),
    }
    const icon = {
      total: faBook,
      finished: faCheckCircle,
      progress: faHourglassHalf,
      pending: faExclamationSquare,
    }
    const iconColor = {
      total: '#4C4C4C',
      finished: '#00A343',
      progress: '#D48806',
      pending: '#FF0000',
    }
    return (
      <Col xs={12} md={12} xl={6}>
        <div className={`gutter-row ${styles.summaryCardWrapper}`}>
          <div>
            <div className="card-title">
              <h5 className={`${styles.cardTitle}`}>{title[typeOf]}</h5>
            </div>
            <div className={`${styles.cardBody}`}>
              <div className={`${styles.cardIconWrapper}`}>
                <div
                  className={`${styles.iconBackground}`}
                  style={{ backgroundColor: iconColor[typeOf] }}
                ></div>
                <FontAwesomeIcon
                  icon={icon[typeOf]}
                  className={`${styles.cardIcon}`}
                  color={iconColor[typeOf]}
                />
              </div>
              <div className={`${styles.cardNumbers}`}>
                <span className={`${styles.totalCourses}`}>{amountOf} </span>
                <span className={`${styles.percentage}`}>
                  {` (${percentageOf}%)`}
                </span>
              </div>
            </div>
          </div>
        </div>
      </Col>
    )
  }

  return (
    <Row
      gutter={[
        { xs: 16, sm: 16, md: 24, lg: 24 },
        { xs: 16, sm: 16, md: 24, lg: 24 },
      ]}
    >
      {ProgressCard('total', totalCourses, 100)}
      {ProgressCard('progress', inProgressCourses, inProgressCoursesPercent)}
      {ProgressCard('pending', pendingCourses, pendingCoursesPercent)}
      {ProgressCard('finished', finishedCourses, finishedCoursesPercent)}
    </Row>
  )
}
